// extracted by mini-css-extract-plugin
export default {"thresholdTextField":"RecentCommentHistoryConfig-thresholdTextField-dbff762c4c4b94d37737feaf1ef89c5a"};